// extracted by mini-css-extract-plugin
export default {"onlyDark":"CVPersonal_onlyDark__pMpaw","onlyLight":"CVPersonal_onlyLight__ovSiv","cv-personal-info":"CVPersonal_cv-personal-info__7+BQY"};